import React from 'react';

const Logo = (props) => {
    if (props.props.info.txtForLogo) {
        return (
            <a style={props.style} className="link-fx font-w600 font-size-lg text-white" href="index.html">
                <span className="smini-visible">
                    <span className="text-white-75">{props.props.info.name.charAt(0).toUpperCase()}</span><span className="text-white">{props.props.info.name.charAt(1)}</span>
                </span>
                <span className="smini-hidden">
                    <span className="text-white-75">{props.props.info.name.charAt(0).toUpperCase()}{props.props.info.name.substr(1, props.props.info.name.length / 2)}</span>
                    <span className="text-white">{props.props.info.name.substr((props.props.info.name.length / 2) + 1, props.props.info.name.length)}</span>
                </span>
            </a>
        )
    } else {
        return (
            <a  style={props.style} className="link-fx font-w600 font-size-lg text-white" href="index.html">
                <span className="smini-visible">
                    <img src={props.props.info.smallLogo} />
                </span>
                <span className="smini-hidden">
                    <img src={props.props.info.logo} style={{height: 45}}/>
                </span>
            </a>
        )
    }
}

export default Logo;